import { Skeleton } from "@material-ui/lab";
import {
    CircularProgress,
    FormControlLabel,
    Grid,
    InputLabel,
    makeStyles,
    Switch,
} from "@material-ui/core";
import axios from "axios";
import { NODE_API_URL, BASE_URL, ASSET_URL } from "../../../env_config";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { Alert, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { GoKey } from "react-icons/go";
import moment from "moment";
import { IoCopyOutline } from "react-icons/io5";
import { TbRefresh } from "react-icons/tb";
import { InputField } from "../ccmode2.0/CcmodeSetupNew/FormFields";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { TfiSave } from "react-icons/tfi";
import { FaExchangeAlt } from "react-icons/fa";
import { SwalWarn } from "../Popup";

const siteUrlValidation = Yup.object().shape({
    siteUrl: Yup.string().required("site url is required"),
    changeSite: Yup.boolean().default(false),
});

const useStyles = makeStyles((theme) => ({
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.up("xs")]: {
            flexDirection: "column",
            alignItems: "start",
            gap: "10px",
        },
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            alignItems: "center",
        },
    },
    copyInner: {
        display: "flex",
        [theme.breakpoints.down("xs")]: {
            flexGrow: 1,
        },
    },
    chipContainer: {
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
    },
    textField: {
        "& .MuiInputBase-input.Mui-disabled": {
            padding: "12.5px 14px",
        },
    },
}));

const WooCommercePluginSettingAuth = ({
    userinfo,
    feedsetting,
    language,
    setRefresh,
}) => {
    const classes = useStyles();
    const [swalopen, setSwalOpen] = useState({
        open: false,
        message: "",
        okFunction: null,
    });

    function handleTestToggle(checked) {
        axios({
            method: "POST",
            url: NODE_API_URL + "/INTL/onOff-Test-Mode",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
            data: {
                test_mode: checked ? "ON" : "OFF",
            },
        })
            .then((res) => {
                if (res && res.data && res.data.success) {
                    setRefresh((prev) => prev + 1);
                    if (res.data.msg === "Test mode Deactivated") {
                        setShowAlert((prev) => ({
                            ...prev,
                            deactivated: true,
                        }));
                    } else {
                        setShowAlert((prev) => ({ ...prev, activated: true }));
                    }
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            })
            .finally(() => {
                setSwalOpen({
                    open: false,
                    message: "",
                    okFunction: null,
                });
            });
    }

    const GenerateTestCredentails = () => {
        axios({
            method: "POST",
            url: NODE_API_URL + "/INTL/mail-ForTest-ModeAPI",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
        })
            .then((res) => {
                if (res && res.data) {
                    setShowAlert((prev) => ({ ...prev, generated: true }));
                    setRefresh((prev) => prev + 1);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            });
    };

    const GenerateLiveCredentails = () => {
        axios({
            method: "POST",
            url: NODE_API_URL + "/INTL/generate-NewToken",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
        }).then((res) => {
            if (res && res.data) {
                setRefresh((prev) => prev + 1);
            }
        });
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result.toISOString();
    }

    const getActive = (date) => {
        let newdate = new Date().getTime();
        let userdate = new Date(date).getTime();
        let status = `<span class="label label-success label-pill label-inline px-5">Active</span>`;
        if (userdate <= newdate) {
            status = `<span class="label label-danger label-pill label-inline px-5">InActive</span>`;
        }
        return status;
    };

    const formik = useFormik({
        initialValues: {
            siteUrl: feedsetting?.wordpress_site_url
                ? new URL(feedsetting.wordpress_site_url).origin
                : "",
            changeSite: false,
        },
        enableReinitialize: true,
        validationSchema: siteUrlValidation,
        onSubmit: handleSubmit,
    });

    async function handleSubmit(values, actions) {
        actions.setSubmitting(true);
        try {
            const response = await axios.get(
                `${NODE_API_URL}/INTL/woocommerce/install?siteUrl=${values.siteUrl}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get(
                            "cust_auth_token"
                        )}`,
                    },
                }
            );

            if (response && response.data && response.data.success) {
                formik.resetForm();
                setRefresh((prev) => prev + 1);
                toast.success(response.data.message);
            }
        } catch (error) {
            if (error?.response?.data?.message === "UnAuthorized!") {
                var cookies = document.cookie.split(";");
                for (var i = 0; i < cookies.length; i++) {
                    if (cookies[i] && !cookies[i].includes("view")) {
                        var equals = cookies[i].indexOf("=");
                        var name =
                            equals > -1
                                ? cookies[i].substr(0, equals)
                                : cookies[i];
                        document.cookie =
                            name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    }
                }

                window.location.replace(`${BASE_URL}/logout`);
            } else if (error?.response?.data?.message) {
                formik.setFieldError("siteUrl", error.response.data.message);
            } else {
                formik.setFieldError("siteUrl", error.message);
            }
        } finally {
            actions.setSubmitting(false);
            setSwalOpen({
                open: false,
                message: "",
                okFunction: null,
            });
        }
    }

    const [showAlert, setShowAlert] = useState({
        activated: false,
        deactivated: false,
        generated: false,
    });

    const [plugin, setPlugin] = useState(null);
    const [pluginLoading, setPluginLoading] = useState(false);

    useEffect(() => {
        setPluginLoading(true);
        axios
            .get(`${NODE_API_URL}/INTL/woocommerce/get-latest-plugin`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
                },
            })
            .then((res) => {
                if (res.data.success) {
                    setPlugin(res.data.data);
                }
            })
            .catch((err) => {})
            .finally(() => {
                setPluginLoading(false);
            });
    }, []);

    if (!feedsetting) {
        return (
            <>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
            </>
        );
    }

    return (
        <div className="row">
            <div className="col-12 ccmode-setting-sticky-header">
                <div
                    className={`col-12 px-0 setting-title pb-5 border-bottom ${classes.cardHeader}`}
                >
                    <div className="d-flex flex-column">
                        <span>WooCommerce Plugin AUTH SETTING</span>
                        <span className="small text-capitalize">
                            WooCommerce Plugin auth setting
                        </span>
                    </div>
                    <div className="">
                        <FormControlLabel
                            className="m-0"
                            labelPlacement="start"
                            control={
                                <Switch
                                    checked={
                                        feedsetting.api_test_mode === "ON"
                                            ? true
                                            : false
                                    }
                                    onClick={(event) => {
                                        const checked = event.target.checked;
                                        setSwalOpen({
                                            open: true,
                                            message: `Are You Sure You Want ${
                                                checked ? "Enable" : "Disable"
                                            } Test Mode?`,
                                            okFunction: () =>
                                                handleTestToggle(checked),
                                        });
                                    }}
                                    value={feedsetting.api_test_mode}
                                    color="primary"
                                />
                            }
                            label={language.SETTING_API_ACTIVATE_TEST}
                        />
                    </div>
                </div>
                <div className="my-3">
                    {showAlert.activated ? (
                        <Alert
                            variant="success"
                            onClose={() =>
                                setShowAlert((prev) => ({
                                    ...prev,
                                    activated: false,
                                }))
                            }
                            dismissible
                        >
                            Test mode Activated, Click on generate credentials
                            to generate test-mode API key and test-mode login.
                        </Alert>
                    ) : (
                        ""
                    )}
                    {showAlert.deactivated ? (
                        <Alert
                            variant="danger"
                            onClose={() =>
                                setShowAlert((prev) => ({
                                    ...prev,
                                    deactivated: false,
                                }))
                            }
                            dismissible
                        >
                            Test mode Deactivated
                        </Alert>
                    ) : (
                        ""
                    )}
                    {showAlert.generated ? (
                        <Alert
                            variant="success"
                            onClose={() =>
                                setShowAlert((prev) => ({
                                    ...prev,
                                    generated: false,
                                }))
                            }
                            dismissible
                        >
                            Test API key generated, and login credentials has
                            been sent to your registered email id.
                        </Alert>
                    ) : (
                        ""
                    )}
                </div>
            </div>
            <div className="col-12">
                <div className="mb-6 mt-3 d-flex justify-content-between align-items-center">
                    <span className="font-weight-bold">
                        <GoKey className="mr-2" />
                        {language.SETTING_API_KEYDETIAL}
                    </span>
                    {plugin?.file_name && plugin?.storage_uri ? (
                        <span style={{ textTransform: "capitalize" }}>
                            <Button
                                color="primary"
                                href={`${ASSET_URL}/wordpress_plugin${
                                    plugin.storage_uri
                                }?${Date.now()}`}
                            >
                                {plugin?.file_name
                                    .replace(/\.zip$/i, "")
                                    .split("-")
                                    .join(" ")}
                            </Button>
                        </span>
                    ) : (
                        ""
                    )}
                </div>
                <table className="table table-bordered">
                    <tr className="bg-gray-100">
                        <th className="text-center">
                            {language.SETTING_API_CREATEDON}
                        </th>
                        <th className="text-center">
                            {language.SETTING_API_TYPE}
                        </th>
                        <th className="text-center">
                            {language.SETTING_API_KEY}
                        </th>
                        <th className="text-center">
                            {language.SETTING_API_STATUS}
                        </th>
                        <th className="text-center">
                            {language.SETTING_API_EXPIRY}
                        </th>
                    </tr>
                    <tr className="">
                        <td className="text-center align-middle">
                            {feedsetting.api_key &&
                            feedsetting.ap_created_date &&
                            feedsetting.api_live_mode === 1 ? (
                                <>
                                    <div>
                                        {feedsetting.ap_created_date
                                            ? moment
                                                  .tz(
                                                      feedsetting.ap_created_date,
                                                      userinfo.timezone
                                                          ? userinfo.timezone
                                                          : Intl.DateTimeFormat().resolvedOptions()
                                                                .timeZone
                                                  )
                                                  .format("YYYY-MM-DD")
                                            : "-"}
                                    </div>
                                    <div className="small text-muted">
                                        {feedsetting.ap_created_date
                                            ? moment
                                                  .tz(
                                                      feedsetting.ap_created_date,
                                                      userinfo.timezone
                                                          ? userinfo.timezone
                                                          : Intl.DateTimeFormat().resolvedOptions()
                                                                .timeZone
                                                  )
                                                  .format("HH:mm:ss")
                                            : "-"}
                                    </div>
                                </>
                            ) : (
                                ""
                            )}
                        </td>
                        <td className="text-center align-middle">Live</td>
                        <td className="text-center align-middle">
                            {feedsetting.api_live_mode === 1 ? (
                                <div>
                                    {feedsetting.api_key ? (
                                        <>
                                            {feedsetting.api_key}
                                            <span className="ml-2 apiIcon">
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip">
                                                            Copy API
                                                        </Tooltip>
                                                    }
                                                >
                                                    <IoCopyOutline
                                                        className="cursor-pointer"
                                                        onClick={() =>
                                                            navigator.clipboard.writeText(
                                                                feedsetting.api_key
                                                            )
                                                        }
                                                    />
                                                </OverlayTrigger>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip">
                                                            Re-generate API
                                                        </Tooltip>
                                                    }
                                                >
                                                    <TbRefresh
                                                        className="ml-2 cursor-pointer"
                                                        onClick={() =>
                                                            GenerateLiveCredentails()
                                                        }
                                                    />
                                                </OverlayTrigger>
                                            </span>
                                        </>
                                    ) : (
                                        <Button
                                            color="primary"
                                            onClick={() =>
                                                GenerateLiveCredentails()
                                            }
                                        >
                                            Generate Credentials
                                        </Button>
                                    )}
                                </div>
                            ) : (
                                <span class="font-weight-bold">
                                    Once Testing is completed, Please contact to
                                    your sales administrator to Activate your
                                    Live API Key
                                </span>
                            )}
                        </td>
                        <td className="text-center align-middle">
                            {feedsetting.api_live_mode === 0 ? (
                                <span class="label label-danger label-pill label-inline px-5">
                                    InActive
                                </span>
                            ) : feedsetting.api_key ? (
                                feedsetting.api === 0 ? (
                                    <span class="label label-danger label-pill label-inline px-5">
                                        Expired
                                    </span>
                                ) : (
                                    <span class="label label-success label-pill label-inline px-5">
                                        Active
                                    </span>
                                )
                            ) : (
                                <span class="label label-danger label-pill label-inline px-5">
                                    InActive
                                </span>
                            )}
                        </td>
                        <td className="text-center align-middle"></td>
                    </tr>
                    <tr>
                        <td className="text-center align-middle">
                            {feedsetting.api_test_key &&
                            feedsetting.aptest_created_date ? (
                                <>
                                    <div>
                                        {feedsetting.aptest_created_date
                                            ? moment
                                                  .tz(
                                                      feedsetting.aptest_created_date,
                                                      userinfo.timezone
                                                          ? userinfo.timezone
                                                          : Intl.DateTimeFormat().resolvedOptions()
                                                                .timeZone
                                                  )
                                                  .format("YYYY-MM-DD")
                                            : "-"}
                                    </div>
                                    <div className="small text-muted">
                                        {feedsetting.aptest_created_date
                                            ? moment
                                                  .tz(
                                                      feedsetting.aptest_created_date,
                                                      userinfo.timezone
                                                          ? userinfo.timezone
                                                          : Intl.DateTimeFormat().resolvedOptions()
                                                                .timeZone
                                                  )
                                                  .format("HH:mm:ss")
                                            : "-"}
                                    </div>
                                </>
                            ) : (
                                ""
                            )}
                        </td>
                        <td className="text-center align-middle">Test</td>
                        <td className="text-center align-middle">
                            {feedsetting.api_test_mode === "ON" ? (
                                <div>
                                    {feedsetting.api_test_key ? (
                                        <>
                                            {feedsetting.api_test_key}{" "}
                                            <span className="ml-2 apiIcon">
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip">
                                                            Copy API
                                                        </Tooltip>
                                                    }
                                                >
                                                    <IoCopyOutline
                                                        className="cursor-pointer"
                                                        onClick={() =>
                                                            navigator.clipboard.writeText(
                                                                feedsetting.api_test_key
                                                            )
                                                        }
                                                    />
                                                </OverlayTrigger>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip">
                                                            Re-generate API
                                                        </Tooltip>
                                                    }
                                                >
                                                    <TbRefresh
                                                        className="ml-2 cursor-pointer"
                                                        onClick={() =>
                                                            GenerateTestCredentails()
                                                        }
                                                    />
                                                </OverlayTrigger>
                                            </span>
                                        </>
                                    ) : (
                                        <Button
                                            color="primary"
                                            onClick={() =>
                                                GenerateTestCredentails()
                                            }
                                        >
                                            Generate Credentials
                                        </Button>
                                    )}
                                </div>
                            ) : (
                                ""
                            )}
                        </td>
                        <td className="text-center align-middle">
                            {feedsetting.api_test_mode === "OFF" ? (
                                <span class="label label-danger label-pill label-inline px-5">
                                    InActive
                                </span>
                            ) : feedsetting.api_test_key ? (
                                feedsetting.api === 0 ? (
                                    <span class="label label-danger label-pill label-inline px-5">
                                        Expired
                                    </span>
                                ) : (
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: getActive(
                                                addDays(
                                                    feedsetting.aptest_created_date,
                                                    30
                                                )
                                            ),
                                        }}
                                    ></div>
                                )
                            ) : (
                                <span class="label label-danger label-pill label-inline px-5">
                                    InActive
                                </span>
                            )}
                        </td>
                        <td className="text-center align-middle">
                            {feedsetting.api_test_key &&
                            feedsetting.aptest_created_date ? (
                                <>
                                    <div>
                                        {feedsetting.aptest_created_date
                                            ? moment
                                                  .tz(
                                                      addDays(
                                                          feedsetting.aptest_created_date,
                                                          30
                                                      ),
                                                      userinfo.timezone
                                                          ? userinfo.timezone
                                                          : Intl.DateTimeFormat().resolvedOptions()
                                                                .timeZone
                                                  )
                                                  .add(7, "days")
                                                  .format("YYYY-MM-DD")
                                            : "-"}
                                    </div>
                                    <div className="small text-muted">
                                        {feedsetting.aptest_created_date
                                            ? moment
                                                  .tz(
                                                      addDays(
                                                          feedsetting.aptest_created_date,
                                                          30
                                                      ),
                                                      userinfo.timezone
                                                          ? userinfo.timezone
                                                          : Intl.DateTimeFormat().resolvedOptions()
                                                                .timeZone
                                                  )
                                                  .format("HH:mm:ss")
                                            : "-"}
                                    </div>
                                </>
                            ) : (
                                ""
                            )}
                        </td>
                    </tr>
                </table>
            </div>
            <hr className="w-100" />
            <div className="col-12 my-3">
                <FormikProvider value={formik}>
                    <Form id="woocommerceSiteUrl">
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                    Registered woocommerce site
                                    <span className="small d-block mt-2 line-height-lg">
                                        your registered woocommerce site.
                                    </span>
                                </InputLabel>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputField
                                    className={classes.textField}
                                    fullWidth
                                    name="siteUrl"
                                    disabled={!formik.values.changeSite}
                                    value={formik.values?.siteUrl || ""}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault(); // Stop form submit
                                        }
                                    }}
                                    InputProps={{
                                        style: {
                                            height: "40px",
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item style={{ marginLeft: "auto" }}>
                                <Button
                                    disabled={formik.isSubmitting}
                                    color="primary"
                                    className="mr-5"
                                    onClick={() => {
                                        formik.setFieldValue(
                                            "changeSite",
                                            !formik.values.changeSite
                                        );
                                    }}
                                >
                                    {formik.values.changeSite ? (
                                        "cancel"
                                    ) : (
                                        <>
                                            <FaExchangeAlt
                                                className="mr-3"
                                                size={13}
                                            />{" "}
                                            Change
                                        </>
                                    )}
                                    {formik.isSubmitting && (
                                        <CircularProgress
                                            size={16}
                                            className={"ml-3"}
                                        />
                                    )}
                                </Button>
                                {formik.values.changeSite ? (
                                    <Button
                                        disabled={formik.isSubmitting}
                                        color="primary"
                                        className=""
                                        onClick={() => {
                                            setSwalOpen({
                                                open: true,
                                                message: `Are You Sure You Want to change registered site?`,
                                                okFunction: () =>
                                                    formik.submitForm(),
                                            });
                                        }}
                                    >
                                        <TfiSave className="mr-3" size={13} />{" "}
                                        Register
                                        {formik.isSubmitting && (
                                            <CircularProgress
                                                size={16}
                                                className={"ml-3"}
                                            />
                                        )}
                                    </Button>
                                ) : (
                                    ""
                                )}
                            </Grid>
                            <Grid
                                item
                                md={12}
                                style={{ textTransform: "capitalize" }}
                            >
                                <hr className="w-100" />
                                <h5>
                                    Follow these steps to complete the
                                    configuration on your WooCommerce store:
                                </h5>
                                {(() => {
                                    const STEPS = [
                                        "Enable Test Mode in the Diamonds on Call WooCommerce diamond plugin settings to use test data.",
                                        "Click Generate Credentials, then click Copy to copy the Test API key to your clipboard.",
                                        "Click Download: Diamonds on Call plugin to download the <code>diamonds-on-call.zip</code> file.",
                                        "In WordPress go to Plugins ▶ Add New ▶ Upload Plugin — upload the ZIP, install it, and activate the plugin.",
                                        "Open Diamonds on Call in the WordPress admin, paste the Test API key into API Credentials, and click Save & Register Site (Status: Online confirms the connection).",
                                        "Add the UI by editing a page and inserting the shortcode: <code>[diamonds-on-call-filter-ui]</code> — then save and refresh the page to see test data.",
                                        "Test checkout and orders: add a Diamonds on Call item and proceed to checkout — availability is verified at checkout, and successful payments create orders in the Diamonds on Call portal.",
                                        "When testing is complete, ask your sales executive to enable Live Mode.",
                                        "After Live Mode is enabled, generate the Live API key in Diamond Feed, replace the Test API key in WordPress, click Save & Register Site, and refresh the storefront to display live inventory",
                                    ];

                                    return (
                                        <div className="p-4">
                                            {STEPS.map((step, idx) => {
                                                const match = step.match(
                                                    /(.*)<code>(.*?)<\/code>(.*)/
                                                );
                                                if (match) {
                                                    const before = match[1].trim();
                                                    const codeText = match[2];
                                                    const after = match[3].trim();

                                                    return (
                                                        <li
                                                            key={idx}
                                                            className="font-size-lg text-semibold my-1"
                                                        >
                                                            {before && (
                                                                <span>
                                                                    {before}{" "}
                                                                </span>
                                                            )}
                                                            <code
                                                                className="px-1 py-0.5 rounded bg-gray-100"
                                                                style={{
                                                                    textTransform:
                                                                        "none",
                                                                }}
                                                            >
                                                                {codeText}
                                                            </code>
                                                            {after && (
                                                                <span>
                                                                    {" "}
                                                                    {after}
                                                                </span>
                                                            )}
                                                        </li>
                                                    );
                                                }

                                                return (
                                                    <li
                                                        key={idx}
                                                        className="font-size-lg text-semibold my-1"
                                                    >
                                                        {step}
                                                    </li>
                                                );
                                            })}
                                        </div>
                                    );
                                })()}
                            </Grid>
                        </Grid>
                    </Form>
                </FormikProvider>
            </div>
            <SwalWarn
                show={swalopen.open}
                message={swalopen.message}
                onHide={() => setSwalOpen((prev) => ({ ...prev, open: false }))}
                onClose={() =>
                    setSwalOpen((prev) => ({ ...prev, open: false }))
                }
                responseOnOk={swalopen.okFunction}
            />
        </div>
    );
};

export default WooCommercePluginSettingAuth;
